// extracted by mini-css-extract-plugin
export default {"head":"NewsList_head__xCPXJ","flipped":"NewsList_flipped__RpfTx","filters":"NewsList_filters__yoI-m","list":"NewsList_list__NeMDp","date":"NewsList_date__V77Gi"};